
var content = require("!!../../../../../../legacy/node_modules/css-loader/index.js!../../../../../../legacy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../legacy/node_modules/postcss-loader/src/index.js??ref--38-2!../../../../../../legacy/node_modules/sass-loader/dist/cjs.js??ref--38-3!../../../../../../legacy/node_modules/vue-loader/lib/index.js??vue-loader-options!./mobile-invitation-form.vue?vue&type=style&index=0&id=a479ae50&prod&lang=scss&scoped=true");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../../../../legacy/node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../../../../legacy/node_modules/css-loader/index.js!../../../../../../legacy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../legacy/node_modules/postcss-loader/src/index.js??ref--38-2!../../../../../../legacy/node_modules/sass-loader/dist/cjs.js??ref--38-3!../../../../../../legacy/node_modules/vue-loader/lib/index.js??vue-loader-options!./mobile-invitation-form.vue?vue&type=style&index=0&id=a479ae50&prod&lang=scss&scoped=true", function() {
		var newContent = require("!!../../../../../../legacy/node_modules/css-loader/index.js!../../../../../../legacy/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../legacy/node_modules/postcss-loader/src/index.js??ref--38-2!../../../../../../legacy/node_modules/sass-loader/dist/cjs.js??ref--38-3!../../../../../../legacy/node_modules/vue-loader/lib/index.js??vue-loader-options!./mobile-invitation-form.vue?vue&type=style&index=0&id=a479ae50&prod&lang=scss&scoped=true");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}